var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"default"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t("question")))]),_c('th',[_vm._v(_vm._s(_vm.$t("answer")))])])]),_c('tbody',_vm._l((_vm.data),function(set){return _c('tr',{key:set.id},[_c('td',[_vm._v(_vm._s(set.question))]),_c('td',[_vm._v(_vm._s(set.answer))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }